import { StoryblokComponent, storyblokEditable } from '@storyblok/react';

import React from 'react';

const GlobalBlok = ({ blok }) => (
  <div {...storyblokEditable(blok)} key={blok._uid} data-test="grid">
    {blok.global
      ? blok.global.map((nestedBlok) => (
          <div key={nestedBlok._uid}>
            <StoryblokComponent blok={nestedBlok} />
          </div>
        ))
      : null}
  </div>
);

export default GlobalBlok;
